var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 16H4C2.9 16 2 15.1 2 14V4C2 2.9 2.9 2 4 2H9C9.55 2 10 1.55 10 1C10 0.45 9.55 0 9 0H4C1.79 0 0 1.79 0 4V14C0 16.21 1.79 18 4 18H9C9.55 18 10 17.55 10 17C10 16.45 9.55 16 9 16Z",
    fill: "#7C8DB5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.71 8.29055L14.71 5.29055C14.32 4.90055 13.69 4.90055 13.3 5.29055C12.91 5.68055 12.91 6.31055 13.3 6.70055L14.59 7.99055H6C5.45 7.99055 5 8.44055 5 8.99055C5 9.54055 5.45 9.99055 6 9.99055H14.59L13.3 11.2805C12.91 11.6705 12.91 12.3005 13.3 12.6905C13.5 12.8905 13.75 12.9805 14.01 12.9805C14.27 12.9805 14.52 12.8805 14.72 12.6905L17.72 9.69055C18.11 9.30055 18.11 8.67055 17.72 8.28055L17.71 8.29055Z",
    fill: "#7C8DB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.80b33db388f55ccebf27ca2ef9b00cbf.svg";
export { ForwardRef as ReactComponent };